export enum CardStatus {
    READ = 'READ', // Card was read
    UNREAD = 'UNREAD', // Card was not read
    NOT_APPLICABLE = 'NOT_APPLICABLE', // Card is not applicable
}
